import React from "react";
import "../../../styles/newsLetterSection.scss";
import { newsLetterData } from "./data";
import { FiArrowRight } from "react-icons/fi";
import Link from "react";

const NewsLetterSection = () => {
  return (
    <section className="news_letter_section_wrapper">
      <div className="container">
        <div
          className="news_letter_wrapper"
          data-aos="zoom-in"
          data-aos-delay="500"
          data-aos-duration="5000"
          data-aos-once="true"
          data-aos-easing="ease-in-out"
        >
          <div className="news_letter_overly"></div>
          <div className="news_letter_content">
            {newsLetterData.map((d, i) => (
              <>
                <div
                  className="left_content"
                  data-aos="fade-up"
                  data-aos-delay="700"
                  data-aos-duration="5000"
                  data-aos-once="true"
                  data-aos-easing="ease-in-out"
                >
                  <div className="subTitle">
                    <h3>{d.subTitle}</h3>
                  </div>
                  <div className="title">
                    <h2>{d.title}</h2>
                  </div>
                  <div className="desc">
                    <p>{d.description}</p>
                  </div>
                  <div className="newsLetterForm">
                    <input
                      type="email"
                      name="news_letter"
                      placeholder="Email address"
                    />
                    <button type="button">
                      Subscribe <FiArrowRight />{" "}
                    </button>
                  </div>
                </div>
                <div
                  className="middle_content"
                  data-aos="fade-up"
                  data-aos-delay="800"
                  data-aos-duration="5000"
                  data-aos-once="true"
                  data-aos-easing="ease-in-out"
                >
                  <div className="content_logo">
                    <img src={d.logo} width="100%" alt="logo" />
                  </div>
                  <div className="desc">
                    <p>{d.description2}</p>
                  </div>
                  <div className="social_links">
                    {d.socialIcons.map((dt, i) => (
                      <span key={i + 1}>
                        <a
                          href={dt.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {dt.icon}
                        </a>
                      </span>
                    ))}
                  </div>
                </div>
                <div
                  className="right_content"
                  data-aos="fade-up"
                  data-aos-delay="900"
                  data-aos-duration="5000"
                  data-aos-once="true"
                  data-aos-easing="ease-in-out"
                >
                  <div className="title">
                    <h2>{d.quickText}</h2>
                  </div>
                  <div className="menu_list">
                    <ul>
                      {d.menuList.map((dt, i) => (
                        <li key={i + 1}>
                          <a href="https://moosesocietynft.io/">{dt}</a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsLetterSection;
